import React from 'react'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import ListErrors from './widgets/ListErrors'
import Phone from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'
import {
    PHONE_LOGIN_GET_PINCODE,
    PHONE_LOGIN_SUBMIT,
    PHONE_LOGIN_PAGE_LOADED,
    PHONE_LOGIN_PAGE_UNLOADED,
    REDIRECT
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.auth,
    inProgress: state.common.inProgress,
})

const mapDispatchToProps = dispatch => ({
    onCheckPinCode: (payload) => {
        dispatch({ type: PHONE_LOGIN_SUBMIT, payload })
    },
    onGetPinCode: (mobile) => {
        const payload = agent.Auth.getPinCode(mobile, 'mobile_login')
        dispatch({ type: PHONE_LOGIN_GET_PINCODE, payload })
    },
    onUnload: () =>
        dispatch({ type: PHONE_LOGIN_PAGE_UNLOADED }),
    onRedirect: () =>
        dispatch({ type: REDIRECT })
})

class PhoneLogin extends React.Component {
    constructor() {
        super()
        this.state = {
            phone: '',
            code: '',
            countDownText: `${i18n.t('system.verify_mobile')}`,
            countDownDisabled: false
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.getPinCode = (mobile) => ev => {
            ev.preventDefault()
            this.setState({ countDownDisabled: true })
            this.props.onGetPinCode(mobile)
            let seconds = 59;
            this.timer = setInterval(() => {
                seconds--
                this.setState({ countDownText: `${i18n.t('authentication.verification_retry_after', { seconds })}` })
                if (seconds <= 0) {
                    this.timer && clearInterval(this.timer);
                    this.setState({ countDownText: `${i18n.t('system.retry_verify_mobile')}`, countDownDisabled: false });
                }
            }, 1000)
        }
        this.checkPinCode = (code) => ev => {
            ev.preventDefault()
            if (this.props.userKey) {
                const payload = agent.Auth.verifyPinCode(this.props.userKey, code, 'mobile_login');
                this.props.onCheckPinCode(payload)
            }
        }
    }
    componentWillMount() {

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            store.dispatch(push(nextProps.redirectTo))
            this.props.onRedirect()
        }
    }
    componentWillUnmount() {
        this.timer && clearTimeout(this.timer);

        this.props.onUnload()
    }

    render() {
        const phone = this.state.phone
        const code = this.state.code
        const inProgress = this.props.inProgress
        return (
            <Translation>
                {
                    (t) => (
                        <div id="focus">
                            <div id="focus-header"><h1>{t('system.name')}</h1></div>
                            <div className="main">
                                <div className="main-wrap">
                                    <div className="focus-wrap">
                                        <div className='box-header'>
                                            <h2>{t('authentication.login_title')}</h2>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('input_label.phone')}</label>
                                            <Phone country="AU" placeholder={'Phone Number'} displayInitialValueAsLocalNumber={false}
                                                value={phone} onChange={phone => this.setState({ phone })}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <button onClick={this.getPinCode(phone)} disabled={this.state.countDownDisabled ? 'disabled' : ''}>{this.state.countDownText}</button>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('input_label.verification_code')}</label>
                                            <input type="text" placeholder={t('input_label.verification_code')} value={code} onChange={this.updateState('code')} />
                                        </div>
                                        <ListErrors errors={this.props.errors} />
                                        <div className="form-item">
                                            {
                                                code.length === 6 ?
                                                    <button
                                                        onClick={this.checkPinCode(code)}
                                                        disabled={this.props.inProgress}>
                                                        {t('authentication.login_button')}
                                                    </button> : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Translation >
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoneLogin)
